import LogoutSubmission from "containers/Login/LogoutSubmission";
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import ImgSrc from 'assets/buy_the_mile_logo.png'
import ImgAnytime from 'assets/anytime.png'

export default function MainHeader() {
  return (
    <Row  style={{ backgroundColor: '#F0F0F0' }} >
      <Col>
        <Link to="/" >
          <img width="150" src={ImgSrc} alt="Buy the mile logo" />
        </Link>
      </Col>
      <Col offset={8} span={10} >
        <img width="150" src={ImgAnytime} alt="Buy the mile logo" />
      </Col>
      <Col offset={1} >
        <LogoutSubmission />
      </Col>
    </Row>
  );

}